import script from "./pmp-ap.vue?vue&type=script&setup=true&lang=ts"
export * from "./pmp-ap.vue?vue&type=script&setup=true&lang=ts"

import "./pmp-ap.vue?vue&type=style&index=0&id=59e168eb&lang=css"

const __exports__ = script;

export default __exports__